import React, { memo } from 'react';
import { SvgIcon, SvgIconProps, Theme, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  root: {
    height: 135,
    width: 148,
  },
}));

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function ReferralsPageIcon({ dark = false, ...rest }: Props) {
  const { palette }: Theme = useTheme();
  const { classes } = useStyles();
  const foreground = dark ? palette.secondary.lightest : palette.primary.dark;

  return (
    <SvgIcon classes={{ root: classes.root }} viewBox="0 0 167 141" {...rest}>
      <svg width="167" height="141" viewBox="0 0 167 141" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.998 59.0895C29.9026 44.3745 48.4236 32.924 58.935 39.8214C63.9617 25.3833 85.338 21.731 94.078 33.5018C100.876 25.5819 118.622 30.6965 116.997 42.2518C126.244 38.0285 142.208 45.8547 138.644 59.0895H35.998Z"
          fill="#13AF77"
        />
        <g filter="url(#filter0_d)">
          <path
            d="M89.1703 35.3045C91.4266 39.2397 96.1043 43.7607 99.5062 45.1705C99.8949 45.3316 100.002 45.8833 99.6686 46.1399L94.1183 50.4094C94.0413 50.4686 93.9493 50.505 93.8522 50.5088C88.9443 50.7026 82.8135 41.9457 79.5168 37.2368L79.4628 37.1597C79.2495 36.8551 79.4332 36.4353 79.801 36.3801L88.6545 35.0524C88.8622 35.0213 89.0659 35.1224 89.1703 35.3045Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter1_d)">
          <path
            d="M78.3548 40.1825C76.0986 36.2474 71.4208 31.7264 68.019 30.3165C67.6303 30.1554 67.523 29.6037 67.8565 29.3472L73.4069 25.0777C73.4839 25.0184 73.5759 24.9821 73.673 24.9783C78.5808 24.7844 84.7116 33.5414 88.0084 38.2503L88.0624 38.3274C88.2756 38.632 88.0919 39.0518 87.7242 39.1069L78.8706 40.4347C78.663 40.4658 78.4592 40.3647 78.3548 40.1825Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter2_d)">
          <path
            d="M130.234 37.2095C132.49 41.1447 137.168 45.6657 140.569 47.0756C140.958 47.2367 141.065 47.7884 140.732 48.0449L135.182 52.3144C135.104 52.3737 135.013 52.41 134.915 52.4138C130.008 52.6076 123.877 43.8507 120.58 39.1418L120.526 39.0647C120.313 38.7601 120.496 38.3403 120.864 38.2851L129.718 36.9574C129.925 36.9263 130.129 37.0274 130.234 37.2095Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter3_d)">
          <path
            d="M119.448 49.8255L127.479 46.7024C127.757 46.5943 127.879 46.2686 127.741 46.0044L122.69 36.3632C122.58 36.1519 122.335 36.0482 122.106 36.1155L114.543 38.34C114.255 38.4248 114.106 38.7433 114.226 39.019L118.808 49.5589C118.915 49.8051 119.198 49.9228 119.448 49.8255Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter4_d)">
          <path
            d="M102.11 33.9936C107.533 33.1445 114.376 30.0766 116.879 27.2355C117.133 26.9474 117.622 26.9737 117.802 27.3129L121.528 34.3359C121.581 34.4352 121.6 34.5491 121.574 34.6584C120.416 39.511 107.894 42.4519 101.471 44.0039C101.138 44.0844 100.825 43.8129 100.857 43.4712L101.682 34.4467C101.704 34.2152 101.88 34.0296 102.11 33.9936Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter5_d)">
          <path
            d="M86.2397 25.1745L78.2089 28.2976C77.931 28.4057 77.8088 28.7314 77.9472 28.9956L82.9974 38.6368C83.108 38.8481 83.3525 38.9518 83.5814 38.8845L91.1445 36.66C91.433 36.5752 91.5819 36.2567 91.462 35.981L86.8794 25.4411C86.7724 25.1949 86.4899 25.0772 86.2397 25.1745Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter6_d)">
          <path
            d="M97.3036 29.0611L90.1241 26.5175C89.8779 26.4303 89.6059 26.5473 89.5001 26.7862L84.6379 37.7539C84.5279 38.002 84.6359 38.2925 84.8812 38.4085L91.0761 41.3387C91.3198 41.454 91.611 41.3553 91.7344 41.1156L97.5812 29.7613C97.7198 29.492 97.5891 29.1623 97.3036 29.0611Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter7_d)">
          <path
            d="M65.3107 56.5101C62.4106 59.528 49.3236 57.7286 42.6755 56.3592C42.4433 56.3114 42.2824 56.107 42.2834 55.87L42.3134 48.7419C42.3149 48.3896 42.6708 48.1486 43.0038 48.2634C50.0164 50.6829 59.3884 48.6792 63.8445 47.1634C64.1526 47.0586 64.4785 47.2651 64.513 47.5887L65.4238 56.1515C65.4378 56.2831 65.4024 56.4147 65.3107 56.5101Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter8_d)">
          <path
            d="M51.1643 47.0191C48.4975 43.7124 53.0887 34.3024 55.4961 27.7961C55.5785 27.5736 55.804 27.4405 56.0388 27.4748L63.4239 28.5537C63.7722 28.6046 63.9604 28.9903 63.7941 29.3005C60.2253 35.9596 60.1617 42.3891 61.0082 46.89C61.0684 47.21 60.819 47.5064 60.4936 47.4951L51.5064 47.1824C51.3741 47.1777 51.2474 47.1221 51.1643 47.0191Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter9_d)">
          <path
            d="M109.976 37.7893C109.227 43.7436 97.843 46.968 91.7339 47.9268C91.4641 47.9692 91.2149 47.7833 91.1719 47.5136L90.1072 40.8477C90.0539 40.5139 90.3417 40.2189 90.6796 40.2088C94.3651 40.098 101.615 35.745 105.273 33.2421C105.476 33.1032 105.75 33.1306 105.92 33.3083L109.844 37.4029C109.943 37.506 109.994 37.6477 109.976 37.7893Z"
            fill="#13AF77"
          />
        </g>
        <circle opacity="0.1" cx="56.85" cy="37.9249" r="1.85" fill={foreground} />
        <g filter="url(#filter10_d)">
          <path
            d="M57.274 37.6262C58.0231 31.6719 69.4075 28.4475 75.5166 27.4887C75.7864 27.4464 76.0355 27.6322 76.0786 27.902L77.1433 34.5678C77.1966 34.9016 76.9088 35.1966 76.5709 35.2068C72.8854 35.3175 65.6353 39.6705 61.9773 42.1734C61.7743 42.3124 61.5005 42.2849 61.3303 42.1072L57.4063 38.0126C57.3075 37.9095 57.2562 37.7679 57.274 37.6262Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter11_d)">
          <path
            d="M42.9981 55.5354C43.7472 49.5811 55.1316 46.3567 61.2407 45.3979C61.5105 45.3555 61.7597 45.5414 61.8027 45.8111L62.8674 52.477C62.9207 52.8108 62.6329 53.1058 62.295 53.1159C58.6095 53.2267 51.3594 57.5797 47.7015 60.0826C47.4984 60.2215 47.2247 60.1941 47.0544 60.0164L43.1304 55.9218C43.0316 55.8187 42.9803 55.6771 42.9981 55.5354Z"
            fill="#13AF77"
          />
        </g>
        <ellipse opacity="0.1" cx="111.425" cy="36.0751" rx="1.85" ry="1.85" fill={foreground} />
        <g filter="url(#filter12_d)">
          <path
            d="M66.4426 44.7972C69.8101 45.4417 78.9522 48.6883 81.2538 49.8892C81.5255 50.031 81.9025 49.9728 82.0837 49.7257L86.4055 43.8323C86.5912 43.579 86.5005 43.2194 86.2163 43.0857C80.2744 40.2905 69.3036 35.4296 68.9493 36.4924C68.6334 37.4401 66.929 41.1876 65.7844 43.6612C65.6001 44.0596 66.0114 44.7146 66.4426 44.7972Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter13_d)">
          <path
            d="M125.235 121.88C121.867 121.235 112.725 117.989 110.423 116.788C110.152 116.646 109.775 116.704 109.594 116.951L105.272 122.845C105.086 123.098 105.177 123.458 105.461 123.591C111.403 126.387 122.374 131.247 122.728 130.185C123.044 129.237 124.748 125.489 125.893 123.016C126.077 122.617 125.666 121.962 125.235 121.88Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter14_d)">
          <path
            d="M94.4428 32.7976C97.8104 33.4422 106.952 36.6888 109.254 37.8897C109.526 38.0315 109.903 37.9733 110.084 37.7262L114.406 31.8328C114.591 31.5795 114.501 31.2199 114.217 31.0862C108.275 28.291 97.3038 23.4301 96.9496 24.4928C96.6337 25.4406 94.9293 29.1881 93.7846 31.6617C93.6003 32.0601 94.0117 32.7151 94.4428 32.7976Z"
            fill="#13AF77"
          />
        </g>
        <circle opacity="0.1" cx="77.2001" cy="43.475" r="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="67.9501" cy="34.225" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="91.0751" cy="34.225" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="121.6" cy="43.475" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="104.025" cy="31.4501" rx="1.85" ry="1.85" fill={foreground} />
        <g filter="url(#filter15_d)">
          <path
            d="M20.941 96.3919C24.3606 96.1429 34.0315 96.9127 36.5655 97.4771C36.8646 97.5437 37.2137 97.3899 37.3248 97.1043L39.974 90.2932C40.0879 90.0005 39.9072 89.6765 39.598 89.621C33.1351 88.4589 21.2801 86.6031 21.2129 87.7213C21.1531 88.7186 20.4767 92.7794 20.0113 95.465C19.9363 95.8976 20.5032 96.4238 20.941 96.3919Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter16_d)">
          <path
            d="M69.6283 37.3917C73.0479 37.1427 82.7188 37.9125 85.2528 38.4769C85.5519 38.5435 85.901 38.3897 86.0121 38.1041L88.6613 31.293C88.7751 31.0002 88.5944 30.6763 88.2853 30.6207C81.8224 29.4587 69.9673 27.6029 69.9002 28.7211C69.8403 29.7183 69.164 33.7792 68.6985 36.4648C68.6236 36.8973 69.1905 37.4236 69.6283 37.3917Z"
            fill="#13AF77"
          />
        </g>
        <ellipse opacity="0.1" cx="78.1249" cy="33.3" rx="1.85" ry="1.85" fill={foreground} />
        <g filter="url(#filter17_d)">
          <path
            d="M130.792 17.9604C133.387 20.2024 139.681 27.5851 141.073 29.7759C141.238 30.0345 141.593 30.1726 141.874 30.0492L148.563 27.1063C148.851 26.9799 148.952 26.623 148.773 26.3651C145.025 20.9735 137.954 11.2784 137.116 12.0217C136.368 12.6845 133.019 15.0777 130.79 16.6476C130.432 16.9004 130.46 17.6734 130.792 17.9604Z"
            fill="#13AF77"
          />
        </g>
        <ellipse opacity="0.15" cx="92.0001" cy="114.343" rx="74.9024" ry="18.9072" fill="#6D8A9F" />
        <g filter="url(#filter18_d)">
          <path
            d="M92.7779 45.5468L83.3519 42.2189C83.0707 42.1196 82.7657 42.2869 82.6984 42.5774L79.8583 54.8297C79.8044 55.062 79.9222 55.3001 80.1396 55.3983L88.4777 59.1643C88.7518 59.2881 89.0723 59.1438 89.1612 58.8565L93.0891 46.1661C93.1685 45.9096 93.0311 45.6362 92.7779 45.5468Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter19_d)">
          <path
            d="M58.0231 54.2102C58.7721 48.2559 70.1565 45.0315 76.2656 44.0727C76.5354 44.0303 76.7846 44.2162 76.8277 44.4859L77.8923 51.1518C77.9457 51.4856 77.6579 51.7806 77.32 51.7907C73.6344 51.9015 66.3843 56.2545 62.7264 58.7574C62.5233 58.8963 62.2496 58.8689 62.0793 58.6912L58.1553 54.5966C58.0565 54.4935 58.0052 54.3519 58.0231 54.2102Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter20_d)">
          <path
            d="M107.878 58.6612C111.899 54.9256 115.859 48.5561 116.346 44.8014C116.395 44.4206 116.816 44.1689 117.155 44.3496L124.17 48.0899C124.269 48.1428 124.348 48.2266 124.388 48.3318C126.14 53.0026 117.403 62.4407 112.944 67.3183C112.713 67.5715 112.302 67.521 112.137 67.2202L107.777 59.2759C107.665 59.0721 107.707 58.8194 107.878 58.6612Z"
            fill="#13AF77"
          />
        </g>
        <ellipse opacity="0.1" cx="68.8749" cy="50.8749" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="101.25" cy="40.7001" rx="1.85" ry="1.85" fill={foreground} />
        <g filter="url(#filter21_d)">
          <path
            d="M92.5522 41.1742L84.5214 44.2973C84.2435 44.4054 84.1213 44.7312 84.2597 44.9953L89.3099 54.6365C89.4205 54.8478 89.665 54.9515 89.8939 54.8842L97.457 52.6598C97.7455 52.5749 97.8944 52.2565 97.7745 51.9807L93.1919 41.4409C93.0849 41.1946 92.8024 41.0769 92.5522 41.1742Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter22_d)">
          <path
            d="M138.778 44.5468L129.352 41.2189C129.07 41.1196 128.765 41.2869 128.698 41.5774L125.858 53.8297C125.804 54.062 125.922 54.3001 126.139 54.3983L134.477 58.1643C134.752 58.2881 135.072 58.1437 135.161 57.8565L139.089 45.1661C139.168 44.9096 139.031 44.6362 138.778 44.5468Z"
            fill="#13AF77"
          />
        </g>
        <circle opacity="0.1" cx="130.85" cy="49.9501" r="1.85" fill={foreground} />
        <g filter="url(#filter23_d)">
          <path
            d="M93.1773 60.5336C91.7599 56.5955 99.1802 45.6663 103.358 40.3164C103.504 40.1296 103.758 40.0761 103.97 40.1822L110.345 43.3724C110.66 43.53 110.718 43.956 110.467 44.2034C105.187 49.4139 102.823 58.7017 102.204 63.3676C102.161 63.6903 101.831 63.8907 101.526 63.7779L93.4485 60.7941C93.3243 60.7482 93.2221 60.6582 93.1773 60.5336Z"
            fill="#13AF77"
          />
        </g>
        <ellipse opacity="0.1" cx="54.0751" cy="51.7999" rx="1.85" ry="1.85" fill={foreground} />
        <g filter="url(#filter24_d)">
          <path
            d="M53.6227 37.0238C50.2031 37.2728 40.5322 36.503 37.9982 35.9387C37.6991 35.872 37.35 36.0259 37.2389 36.3115L34.5897 43.1226C34.4758 43.4153 34.6566 43.7392 34.9657 43.7948C41.4286 44.9569 53.2837 46.8126 53.3508 45.6944C53.4106 44.6972 54.087 40.6363 54.5524 37.9507C54.6274 37.5182 54.0605 36.9919 53.6227 37.0238Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter25_d)">
          <path
            d="M112.941 52.3922C116.36 52.1432 126.031 52.913 128.565 53.4773C128.864 53.544 129.213 53.3901 129.324 53.1045L131.974 46.2934C132.087 46.0007 131.907 45.6768 131.598 45.6212C125.135 44.4591 113.28 42.6034 113.212 43.7216C113.153 44.7188 112.476 48.7797 112.011 51.4653C111.936 51.8978 112.503 52.4241 112.941 52.3922Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter26_d)">
          <path
            d="M37.3297 56.2075C35.0734 52.2723 30.3957 47.7513 26.9938 46.3414C26.6051 46.1803 26.4978 45.6286 26.8314 45.3721L32.3817 41.1026C32.4587 41.0433 32.5507 41.007 32.6478 41.0032C37.5557 40.8093 43.6865 49.5663 46.9833 54.2752L47.0372 54.3523C47.2505 54.6569 47.0668 55.0767 46.6991 55.1318L37.8455 56.4596C37.6378 56.4907 37.4341 56.3896 37.3297 56.2075Z"
            fill="#13AF77"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M132.209 64.9261C132.523 64.6084 133.064 64.8309 133.064 65.2777L133.064 105.401C133.064 105.64 132.87 105.834 132.631 105.834C132.524 105.834 132.42 105.794 132.341 105.722L111.339 86.7664C111.128 86.5754 111.119 86.2463 111.319 86.0436L132.209 64.9261ZM103.448 94.0005C103.636 93.8105 103.94 93.8019 104.138 93.981L125.725 113.465C127.579 115.138 129.977 116.064 132.464 116.064H133.064C138.653 116.064 143.184 111.484 143.184 105.834V56.6476C143.184 56.5159 143.236 56.3895 143.328 56.2959L157.05 42.4252C159.319 40.1307 159.319 36.4105 157.05 34.1159C154.78 31.8214 151.1 31.8214 148.83 34.1159L132.004 51.1254C131.91 51.2203 131.782 51.2738 131.648 51.2738H33.1854C30.4763 51.2738 28.8724 54.3391 30.3971 56.6029L53.1697 90.4148C53.5484 90.9771 54.2289 91.253 54.8931 91.144C70.466 88.5898 77.5444 97.7042 79.5648 103.691C79.817 104.438 80.4873 104.981 81.2683 104.981H90.4898C91.8318 104.981 93.1187 104.442 94.0676 103.483L103.448 94.0005ZM61.3833 122.031C67.9037 122.031 73.1896 116.688 73.1896 110.096C73.1896 103.505 67.9037 98.1612 61.3833 98.1612C54.8629 98.1612 49.577 103.505 49.577 110.096C49.577 116.688 54.8629 122.031 61.3833 122.031Z"
          fill="url(#paint0_linear)"
        />
        <g filter="url(#filter27_d)">
          <path
            d="M114.793 78.9607C117.387 81.2026 123.681 88.5853 125.074 90.7762C125.238 91.0348 125.594 91.1729 125.874 91.0495L132.564 88.1066C132.851 87.9801 132.953 87.6233 132.773 87.3654C129.025 81.9737 121.954 72.2787 121.116 73.0219C120.369 73.6847 117.019 76.0779 114.791 77.6478C114.432 77.9007 114.461 78.6737 114.793 78.9607Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter28_d)">
          <path
            d="M82.2415 64.1092C78.8902 63.385 69.8276 59.9226 67.5552 58.6674C67.2869 58.5192 66.9086 58.5685 66.7216 58.8112L62.2613 64.6005C62.0696 64.8493 62.1518 65.211 62.4327 65.3514C68.3067 68.2867 79.1592 73.4062 79.5385 72.3522C79.8768 71.4122 81.6696 67.7062 82.8725 65.2604C83.0663 64.8665 82.6705 64.2019 82.2415 64.1092Z"
            fill="#13AF77"
          />
        </g>
        <g filter="url(#filter29_d)">
          <path
            d="M24.1354 57.7553C20.1137 61.4909 16.1542 67.8604 15.6673 71.6151C15.6179 71.9959 15.1975 72.2476 14.8587 72.0669L7.84353 68.3266C7.74436 68.2737 7.66481 68.1899 7.62533 68.0847C5.87275 63.4139 14.6107 53.9758 19.069 49.0982C19.3005 48.845 19.7113 48.8956 19.8764 49.1963L24.2366 57.1406C24.3485 57.3444 24.3057 57.5971 24.1354 57.7553Z"
            fill="#13AF77"
          />
        </g>
        <ellipse opacity="0.1" cx="140.1" cy="21.275" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="121.6" cy="49.025" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="103.1" cy="48.1" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="91.9999" cy="50.8749" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="72.5751" cy="65.675" rx="1.85" ry="1.85" fill={foreground} />
        <circle opacity="0.1" cx="36.4999" cy="49.025" r="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="44.8251" cy="40.7001" rx="1.85" ry="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="30.025" cy="92.4999" rx="1.85" ry="1.85" fill={foreground} />
        <circle opacity="0.1" cx="123.45" cy="82.3251" r="1.85" fill={foreground} />
        <circle opacity="0.1" cx="115.125" cy="123.025" r="1.85" fill={foreground} />
        <ellipse opacity="0.1" cx="15.225" cy="61.0499" rx="1.85" ry="1.85" fill={foreground} />
        <defs>
          <filter
            id="filter0_d"
            x="72.3723"
            y="31.0469"
            width="34.4954"
            height="29.4652"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter1_d"
            x="60.6575"
            y="20.9751"
            width="34.4954"
            height="29.4652"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter2_d"
            x="113.436"
            y="32.9519"
            width="34.4954"
            height="29.4652"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter3_d"
            x="107.184"
            y="32.0952"
            width="27.6137"
            height="27.7645"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter4_d"
            x="93.8545"
            y="23.0374"
            width="34.7307"
            height="30.9808"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter5_d"
            x="70.8899"
            y="21.1404"
            width="27.6137"
            height="27.7645"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter6_d"
            x="77.595"
            y="22.4888"
            width="27.0419"
            height="28.8981"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter7_d"
            x="35.2834"
            y="43.136"
            width="37.1433"
            height="25.0191"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter8_d"
            x="43.3569"
            y="23.4695"
            width="27.4985"
            height="34.0259"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter9_d"
            x="83.1008"
            y="29.1538"
            width="33.8792"
            height="28.7789"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter10_d"
            x="50.2705"
            y="23.4827"
            width="33.8792"
            height="28.779"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter11_d"
            x="35.9946"
            y="41.3918"
            width="33.8792"
            height="28.779"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter12_d"
            x="58.7393"
            y="32.343"
            width="34.7633"
            height="27.6221"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter13_d"
            x="98.1748"
            y="112.712"
            width="34.7633"
            height="27.6221"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter14_d"
            x="86.7395"
            y="20.3435"
            width="34.7633"
            height="27.6221"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter15_d"
            x="13.0046"
            y="83.376"
            width="34.0038"
            height="24.1165"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter16_d"
            x="61.6919"
            y="24.3757"
            width="34.0038"
            height="24.1165"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter17_d"
            x="123.532"
            y="7.9812"
            width="32.3298"
            height="32.1137"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter18_d"
            x="72.8452"
            y="38.1902"
            width="27.2662"
            height="31.0187"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter19_d"
            x="51.0195"
            y="40.0667"
            width="33.8792"
            height="28.779"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter20_d"
            x="100.715"
            y="40.2898"
            width="30.9024"
            height="37.1909"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter21_d"
            x="77.2024"
            y="37.1401"
            width="27.6137"
            height="27.7645"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter22_d"
            x="118.845"
            y="37.1902"
            width="27.2662"
            height="31.0187"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter23_d"
            x="86"
            y="36.1282"
            width="31.6232"
            height="37.6813"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter24_d"
            x="27.5554"
            y="31.9233"
            width="34.0038"
            height="24.1165"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter25_d"
            x="105.004"
            y="39.3762"
            width="34.0038"
            height="24.1165"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter26_d"
            x="19.6323"
            y="37"
            width="34.4954"
            height="29.4652"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter27_d"
            x="107.533"
            y="68.9814"
            width="32.3298"
            height="32.1137"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter28_d"
            x="55.1572"
            y="54.5837"
            width="34.7659"
            height="27.9091"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter29_d"
            x="0.39624"
            y="44.9358"
            width="30.9024"
            height="37.1909"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear"
            x1="41.0123"
            y1="67.5258"
            x2="125.671"
            y2="141.549"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#404F9B" />
            <stop offset="1" stopColor="#313353" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export default memo(ReferralsPageIcon);
